export default __webpack_public_path__ + "static/media/db_black.3037bcd9.png";